export class MarkAsDirty {
    static readonly type = '[Editor.Frame] Mark as Dirty';
}

export class OpenFrameControls {
    static readonly type = '[Editor.Frame] Open Frame Controls';
}
